import axios from 'axios'
export default {

    AllGradDegrees(context)
    {
        context.commit('AllGradDegrees')
    },
    AllUndergradDegrees(context)
    {
        context.commit('AllUndergradDegrees')
    },
    getAllAcademicEvents(context)
    {
        context.commit('getAllAcademicEvents')
    },
    getAllEvents(context)
    {
        context.commit('getAllEvents')
    },
    getArticles(context)
    {
        context.commit('getArticles')
    },
    getSportArticles(context)
    {
        context.commit('getSportArticles')
    },
    AllCareers(context)
    {
        context.commit('AllCareers')
    },
    getAllFeatures(context)
    {
        context.commit('getAllFeatures')
    },
    getArticle(context, data)
    {
        context.commit('getArticle', data)
    },
    getDegree(context, data)
    {
        context.commit('getDegree', data)
    },
    getFeature(context, data)
    {
        context.commit('getFeature', data)
    },
    getGradDegree(context, data)
    {
        context.commit('getGradDegree', data)
    },
    getNewAcademicEvents(context, data)
    {
        context.commit('getNewAcademicEvents', data)
    },
    getNewEvents(context, data)
    {
        context.commit('getNewEvents', data)
    },
    AllExtensionDegrees(context, data)
    {
        context.commit('AllExtensionDegrees', data)
    },
    getEventCurrentMonth(context, payload){
      return new Promise((resolve, reject) => {
          axios({
            method: 'post',
            url: context.state.rootUrl + 'getCurrentMonth',
            //headers: {'Authorization': 'Bearer '+ Vue.localStorage.get('token') },
            data: payload,
          })
            .then(response => {
              console.log(response.data.CalendarMonth)
              context.commit('setCurrentMonth', response.data.CalendarMonth)
              resolve(response)

            })
            .catch(err => {
              reject(err)
            })
      })
    },
    getAcademicCurrentMonth(context, payload){
      return new Promise((resolve, reject) => {
          axios({
            method: 'post',
            url: context.state.rootUrl + 'getCurrentMonth',
            //headers: {'Authorization': 'Bearer '+ Vue.localStorage.get('token') },
            data: payload,
          })
            .then(response => {
              console.log(response.data.CalendarMonth)
              context.commit('setAcademicCurrentMonth', response.data.CalendarMonth)
              resolve(response)

            })
            .catch(err => {
              reject(err)
            })
      })
    },
    getSearchResult(context, payload){
      return new Promise((resolve, reject) => {
          axios({
            method: 'post',
            url: context.state.keywordUrl + 'getResult',
            //headers: {'Authorization': 'Bearer '+ Vue.localStorage.get('token') },
            data: payload,
          })
            .then(response => {
              //console.log(response)
              context.commit('setKeywordResult', response)
              //resolve(response)

            })
            .catch(err => {
              reject(err)
            })
      })
    },
    getUndergraduateDegrees(context, payload){
      return new Promise((resolve, reject) => {
          axios({
            method: 'get',
            url: context.state.newRootUrl + 'programs?per_page=100',
            //headers: {'Authorization': 'Bearer '+ Vue.localStorage.get('token') },
            //data: payload,
          })
            .then(response => {
              console.log(response.data)
              context.commit('setDegreeList', response.data)
              //resolve(response)

            })
            .catch(err => {
              reject(err)
            })
      })
    },
    getGraduateDegrees(context, payload){
      return new Promise((resolve, reject) => {
          axios({
            method: 'get',
            url: context.state.newRootUrl + 'graduate-programs?per_page=100',
            //headers: {'Authorization': 'Bearer '+ Vue.localStorage.get('token') },
            //data: payload,
          })
            .then(response => {
              console.log(response.data)
              context.commit('setGradDegreeList', response.data)
              //resolve(response)

            })
            .catch(err => {
              reject(err)
            })
      })
    },

    getUndergraduateDegreesByCollege(context, payload){
      return new Promise((resolve, reject) => {
          axios({
            method: 'post',
            url: context.state.cmsApiUrl + 'degree/getUndergradDegreesByCollege',
            //headers: {'Authorization': 'Bearer '+ Vue.localStorage.get('token') },
            data: payload,
          })
            .then(response => {
              console.log(response)
                if (payload.department === 'TED'){
                    context.commit('setTEDDegreeList', response)
                }
                if (payload.department === 'CNAS') {
                    context.commit('setCNASDegreeList', response)
                }

              //resolve(response)

            })
            .catch(err => {
              reject(err)
            })
      })
    },
    getRandomDegrees(context, payload){
      return new Promise((resolve, reject) => {
          axios({
            method: 'post',
            url: context.state.cmsApiUrl + 'degree/getRandomUndergradDegrees',
            //headers: {'Authorization': 'Bearer '+ Vue.localStorage.get('token') },
            data: payload,
          })
            .then(response => {
              console.log(response)
              context.commit('setRandomDegreeList', response)
                console.log("past here")
              //resolve(response)

            })
            .catch(err => {
              reject(err)
            })
      })
    },
    getNewDegree(context, payload){

      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: context.state.newRootUrl + `programs?search=${payload.degree}`,
          //headers: {'Authorization': 'Bearer '+ Vue.localStorage.get('token') },
          data: payload,
        })
          .then(response => {
            console.log(response)
            context.commit('singleUndergrad', response.data)
            //resolve(response)

          })
          .catch(err => {
            reject(err)
          })
      })
  },
    getSportDayScores(context, payload){

      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: "https://sports.ncu.edu.jm/house-tally-results-data?token=21232f297a57a5a743894a0e4a801fc3",
          //headers: {'Authorization': 'Bearer '+ Vue.localStorage.get('token') },
          //data: payload,
        })
          .then(response => {
            //console.log(response.data);
            //let houses = [];

            //context.sportsScores.push(houses)
            //console.log(houses)
            context.commit('sportscores', response)
            //resolve(response)

          })
          .catch(err => {
            reject(err)
          })
      })
  },
    getBanners( context){

      return new Promise((resolve, reject) => {
          axios({
              method: 'get',
              url: context.state.rootUrl + 'getWebBanners',
              //headers: {'Authorization': 'Bearer '+ Vue.localStorage.get('token') },
          })
              .then(response => {

                  if (response.status === 201 ){
                      context.commit('getBanners', response)
                      resolve()
                  }
                  else{
                      console.log('1')
                  }
              })
              .catch(err => {
                  console.log('2')
              })
      })
  },
    async sendRequest({ state, commit }, payload){

        const data = payload
        console.log(data)
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                axios({
                    method: 'post',
                    url: state.rootUrlDev + 'info/addInfoRequest',
                    data: {
                        entryDate: payload.entryDate,
                        firstName: payload.firstName,
                        middleName: payload.middleName,
                        lastName: payload.lastName,
                        telephone: payload.telephone,
                        email: payload.email,
                        gender: payload.gender,
                        location: payload.location,
                        lastSchool: payload.lastSchool,
                        grade: payload.grade,
                        degreeType: payload.degreeType,
                        additionInfo: payload.additionInfo,
                        programChoice: payload.programChoice,
                        degreeChoice: payload.degreeChoice,
                        churchDistrict: payload.churchDistrict,
                        churchConference: payload.churchConference,
                    },
                    headers: { 'X-Requested-With': 'XMLHttpRequest' }
                })
                    .then(function (response) {
                        //commit('login')
                        resolve(response)
                    })
                    .catch(function (error) {
                        console.log(error);
                        reject()

                    });

            }, 1000)
        })
    },

}
